import React from 'react'
import { Button } from '~shared/components/button'
import { TResProgramImages } from '@/modules/shared/widgets/Header/fractals/api/getHeaderData/types'
import { cn } from '~shared/utils/cn'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Program } from '~shared/api/categories/types'
import Link from 'next/link'

type Props = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
  isDrawer?: boolean
  className?: string
}

export const ProgramCategories: React.FC<Props> = ({
  categories,
  isDrawer,
  className
}) => {
  const [currCat, setCurCat] = React.useState('all')

  const allPrograms = categories?.categories?.reduce((acc: Program[], el) => {
    el?.programs?.forEach(item => acc.push(item))
    return acc
  }, [])
  return (
    <div
      className={cn(
        'md:p-0  max-w-[1150px]',
        isDrawer
          ? 'mt-[16px] mb-[24px]'
          : 'bg-[#F2F2F2] p-[16px] rounded-[24px] md:bg-inherit',
        className
      )}>
      <div
        className={cn(
          'flex gap-[8px] text-white flex-wrap',
          isDrawer ? 'my-[24px]' : 'mb-[16px]'
        )}>
        <Button
          className={cn(
            'px-[12px] lg:px-[16px] h-[37px] rounded-[24px] text-[14px] md:text-[16px] hover:bg-[#3A52EE] hover:text-white',
            {
              'bg-[#3A52EE] text-[#EBEEFD]': currCat === 'all',
              'md:bg-[#EBEEFD] bg-[#E0E2F2] text-[#3A52EE]': currCat !== 'all',
              'text-[14px] px-[8px] h-[30px]': isDrawer
            }
          )}
          onClick={() => setCurCat('all')}>
          все программы
        </Button>
        {categories?.categories?.map(el => (
          <Button
            className={cn(
              'px-[12px] lg:px-[16px] h-[37px] text-[14px] md:text-[16px] rounded-[24px] gap-[4px] lg:gap-[6px] hover:bg-[#3A52EE] hover:text-white',
              {
                'bg-[#3A52EE] text-[#EBEEFD]': currCat === el.slug,
                'md:bg-[#EBEEFD] bg-[#E0E2F2] text-[#3A52EE]':
                  currCat !== el.slug,
                'text-[14px]  px-[8px] h-[30px] gap-[4px]': isDrawer,
                lowercase: el.name !== 'MBA'
              }
            )}
            key={el.name}
            onClick={() => setCurCat(el?.slug ?? '')}>
            {el.logo && (
              <img
                src={el.logo.url}
                alt='program logo'
                className={cn(
                  isDrawer ? 'w-[16px] h-[16px]' : 'w-[21px] h-[21px]'
                )}
              />
            )}
            {el.name}
          </Button>
        ))}
      </div>
      {!isDrawer && (
        <div className='h-[1px] bg-[#0000001A] mb-[16px] md:hidden' />
      )}
      <div className={cn('flex gap-[8px] flex-wrap')}>
        {categories?.faculties
          ?.filter(
            faculty =>
              categories?.categories
                ?.filter(element => element.slug === currCat)[0]
                ?.programs.filter(item => item.faculty.slug === faculty.slug)
                .length !== 0
          )
          .map(el => (
            <Link
              href={`/${currCat === 'all' ? 'programmy' : currCat}--fakultet--${
                el.slug
              }`}
              className={cn(
                'text-[#3A52EE] lowercase rounded-[24px] h-[37px] text-[14px] md:text-[16px] px-[12px] lg:px-[16px] gap-[4px] lg:gap-[10px] text-left hover:bg-[#EBEEFD] group flex items-center',
                isDrawer
                  ? 'bg-[#F2F2F2] text-[14px] h-[30px] px-[8px]'
                  : 'bg-white'
              )}
              key={el.slug}
              prefetch={false}>
              {el.name}
              {!isDrawer && (
                <span className='inline-flex items-center justify-center duration-200 ease-in-out text-[9px] min-w-[20px] min-h-[20px] rounded-[50%] text-[#3A52EE] bg-[#EBEEFD] group-hover:bg-white'>
                  {currCat === 'all'
                    ? allPrograms?.filter(item => item.faculty.slug === el.slug)
                        .length
                    : categories?.categories
                        ?.filter(element => element.slug === currCat)[0]
                        ?.programs.filter(item => item.faculty.slug === el.slug)
                        .length}
                </span>
              )}
            </Link>
          ))}
      </div>
    </div>
  )
}
